import request from '@/router/axios';

// 新增应急储备点
export const add = (data) => {
  return request({
    url: '/api/produce/emergency-storage-point/insert',
    method: 'post',
    data,
  });
};

// 更新应急储备点
export const update = (data) => {
  return request({
    url: '/api/produce/emergency-storage-point/update',
    method: 'post',
    data,
  });
};

// 获取应急储备点详情
export const getDetail = (id) => {
  return request({
    url: '/api/produce/emergency-storage-point/select/id',
    method: 'get',
    params: { id },
  });
};

// 获取应急储备点列表（分页）
export const getList = (data) => {
  return request({
    url: '/api/produce/emergency-storage-point/select/page',
    method: 'post',
    data,
  });
};

// 获取应急储备点列表（去重分页）
export const getDistinctList = (data) => {
  return request({
    url: '/api/produce/emergency-storage-point/select/distinct/page',
    method: 'post',
    data,
  });
};

// 删除应急储备点（单个）
export const remove = (id) => {
  return request({
    url: '/api/produce/emergency-storage-point/delete/id',
    method: 'get',
    params: { id },
  });
};

// 批量删除应急储备点
export const removeBatch = (ids) => {
  return request({
    url: '/api/produce/emergency-storage-point/delete/ids',
    method: 'get',
    params: { ids },
  });
};

export const downloadImportTemplate = () => {
  return request({
    url: '/api/produce/emergency-storage-point/import-template',
    method: 'get',
    responseType: 'blob',
  });
};

export const exportExcel = (data) => {
  return request({
    url: '/api/produce/emergency-storage-point/export/excel',
    method: 'post',
    data,
    responseType: 'blob',
  });
};

export const getMaterials = (storagePointId) => {
  return request({
    url: '/api/produce/emergency-storage-point/materials',
    method: 'get',
    params: { storagePointId },
  });
};

export const getContractExtpage = (params) => {
  return request({
    url: '/api/produce/transport-contract-ext/select/contractExtpage',
    method: 'get',
    params
  })
}
